import { NavContext } from '@superrb/gatsby-addons/context'
import { useIsMobile } from '@superrb/gatsby-addons/hooks'
import React, { useContext } from 'react'

const MenuToggle = ({
  className,
  label = 'Open Nav',
  closeLabel = 'Close Nav',
  ...props
}) => {
  const { navOpen, toggleNav } = useContext(NavContext)
  const isMobile = useIsMobile()

  return (
    <button
      className={`menu-toggle ${className}`}
      onClick={() => {
        toggleNav()
      }}
      aria-expanded={navOpen}
      aria-controls="main-nav"
      aria-hidden={!isMobile}
      {...props}
    >
      <span className="screenreader-text">{navOpen ? closeLabel : label}</span>
    </button>
  )
}

export default MenuToggle
